import { getAction, postAction, putAction, deleteAction } from '@/api/manage'

const PREFIX = '/api/plugin/member'

// ========== 等级（2802） ==========
export const levelList = () => getAction(`${PREFIX}/levels`)
export const levelCreate = (data) => postAction(`${PREFIX}/levels`, data)
export const levelUpdate = (id, data) => putAction(`${PREFIX}/levels/${id}`, data)
export const levelToggle = (id) => putAction(`${PREFIX}/levels/${id}/status`)
export const levelDelete = (id) => deleteAction(`${PREFIX}/levels/${id}`)

// ========== 会员档案（2801） ==========
export const memberList = (params) => getAction(`${PREFIX}/members`, params)
export const memberDetail = (id) => getAction(`${PREFIX}/members/${id}`)
export const memberUpdateLevel = (id, data) => putAction(`${PREFIX}/members/${id}/level`, data)
export const memberCard = (id) => getAction(`${PREFIX}/members/${id}/card`)

// ========== 会员价（2803） ==========
export const priceList = (params) => getAction(`${PREFIX}/prices`, params)
export const priceAddItems = (materialIds) => postAction(`${PREFIX}/prices/items`, { materialIds })
export const priceRemoveItem = (materialId) => deleteAction(`${PREFIX}/prices/items/${materialId}`)
export const priceSaveBatch = (items) => putAction(`${PREFIX}/prices/batch`, { items })
export const priceDiscountFlag = (materialId, excluded) => putAction(`${PREFIX}/prices/discount-flag`, { materialId, excluded })
export const priceImport = (content, dryRun) => postAction(`${PREFIX}/prices/import`, { content, dryRun })

// ========== 商城展示设置（商品管理行入口） ==========
export const goodsDisplayGet = (materialId) => getAction(`${PREFIX}/goods/display/${materialId}`)
export const goodsDisplaySave = (materialId, data) => putAction(`${PREFIX}/goods/display/${materialId}`, data)

// ========== 零售收银台（040103） ==========
export const cashierGoods = (params) => getAction(`${PREFIX}/cashier/goods`, params)
export const cashierMemberSearch = (keyword) => getAction(`${PREFIX}/cashier/member-search`, { keyword })
export const cashierSettle = (data) => postAction(`${PREFIX}/cashier/settle`, data)
export const cashierReceipt = (headId) => getAction(`${PREFIX}/cashier/receipt/${headId}`)

// ========== 商城订单码核销（P0-9） ==========
export const cashierScanParse = (qrContent) => getAction(`${PREFIX}/cashier/scan/parse`, { qrContent })
export const cashierScanVerify = (qrContent) => postAction(`${PREFIX}/cashier/scan/verify`, { qrContent })

// ========== 收银台补全（退货/交班/锁屏） ==========
export const cashierReturnOrder = (keyword) => getAction(`${PREFIX}/cashier/return/order`, { keyword })
export const cashierReturnSettle = (data) => postAction(`${PREFIX}/cashier/return/settle`, data)
export const cashierShiftReport = (params) => getAction(`${PREFIX}/cashier/shift/report`, params)
export const cashierUnlock = (password) => postAction(`${PREFIX}/cashier/unlock`, { password })

// ========== 收银真实支付（B扫C 付款码 / C扫B 扫码收款） ==========
export const cashierPayBar = (data) => postAction(`${PREFIX}/cashier/pay-bar`, data)
export const cashierPayQrcode = (data) => postAction(`${PREFIX}/cashier/pay-qrcode`, data)
export const cashierPayStatus = (payOrderNo) => getAction(`${PREFIX}/cashier/pay-status`, { payOrderNo })
export const cashierPayCancel = (payOrderNo) => postAction(`${PREFIX}/cashier/pay-cancel`, { payOrderNo })

// ========== 会员积分（副屏会员态数据源） ==========
export const cashierMemberPoints = (memberId, amount) => getAction(`${PREFIX}/cashier/member-points`, { memberId, amount })

// ========== 副屏广告（2804） ==========
export const advertList = () => getAction(`${PREFIX}/adverts`)
export const advertCreate = (data) => postAction(`${PREFIX}/adverts`, data)
export const advertUpdate = (id, data) => putAction(`${PREFIX}/adverts/${id}`, data)
export const advertToggle = (id) => putAction(`${PREFIX}/adverts/${id}/status`)
export const advertDelete = (id) => deleteAction(`${PREFIX}/adverts/${id}`)

// ========== 副屏公开数据（免登录，挂 mall 白名单前缀） ==========
export const screenAdvert = (tenantId) => getAction(`${PREFIX}/mall/screen/advert`, { tenantId })
